export default __webpack_public_path__ + "static/media/Sonia-Khandelwal.8ef0eb7e.jpg";